import { equal } from "@ember/object/computed";
import RestModel from "discourse/models/rest";
export const CREATED = 0;
export const TRANSITIONED_TO = 1;
export const EDITED = 2;
export default class ReviewableHistory extends RestModel {
  static #_ = (() => dt7948.g(this.prototype, "created", [equal("reviewable_history_type", CREATED)]))();
  #created = (() => (dt7948.i(this, "created"), void 0))();
}